import MenuNames from "../../../constants/Menu/MenuNames.json";
import BulkRequestDriverInformation from "../../../views/BulkRequestDriverInformation";

const bulkRequestDriverInformation = [
  {
    menuName: MenuNames.DRIVER_INFO_BULK_REQUEST,
    path: "/bulk-request-driver-information",
    component: BulkRequestDriverInformation,
    exact: true,
  },
];

export default bulkRequestDriverInformation;
